import {SharingEventLogger} from '../analytics/sharing';

export const addListenerByShareContainer = ($target, $shareContainer) => {
  $shareContainer?.addEventListener('click', e => {
    e.preventDefault();

    const {title, url, id} = $target?.dataset || {};

    if (!title && !url && !id) {
      return null;
    }

    const text = $shareContainer.innerText;

    SharingEventLogger.clickTrendShareButton(text);

    if (navigator.share) {
      const trackingUrl = new URL(url);

      trackingUrl.searchParams.append('utm_source', 'web-share-api');

      navigator.share({title, url: trackingUrl.toString()}).catch(console.error);
    } else {
      import(/* webpackChunkName: "share-modal" */ './share-modal').then(module => {
        module.default(url, title, id);
      });
    }
  });
};

export const onCopyLink = ($target, utmMedium) => {
  const $buttonCopyLink = $target?.querySelector('.js-copy-link');

  $buttonCopyLink?.addEventListener('click', () => {
    if ($target?.dataset?.url) {
      import(/* webpackChunkName: "copy-to-clipboard" */ './copy-to-clipboard').then(module => {
        module.default($target.dataset.url, $buttonCopyLink, utmMedium);
      });
    }
  });
};
